import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  codigoGrupo: Yup.string().min(1).max(10).required(),
  tipo: Yup.string().min(1).max(10).required(),
  monto: Yup.number().min(1).required(),
  glosa: Yup.string().min(5).max(500).notRequired()
})
